import {
  BarChart as BarChartIcon,
  Users as UsersIcon,
  File as FileIcon,
  Archive,
  PlusSquare
} from 'react-feather';
import CloudQueueIcon from '@mui/icons-material/CloudQueue';

const services = {
  AHC_Dashboard: {
    icon: 'ahc',
    title: 'Annual Health Check',
    options: [],
    redirectUrl: '/app/superset/Utilization'
  },
  OPD: {
    icon: 'ahc',
    title: 'OPD',
    options: [],
    redirectUrl: '/app/superset/OPDMAUtilization'
  },
  GOLD_Utilization: {
    icon: 'ahc',
    title: 'GOLD',
    options: [],
    redirectUrl: '/app/superset/GOLDUtilization'
  },
  Vaccination: {
    icon: 'vaccination',
    title: 'Vaccination',
    options: [],
    redirectUrl: '/app/dashboard'
  },
  AHC: {
    icon: 'ahc',
    title: 'Annual Health Checkup',
    options: [],
    redirectUrl: '/app/ahc/dashboard'
  },
  Gold: {
    icon: 'mbGold',
    title: 'Consultation',
    options: [],
    redirectUrl: '/app/gold/dashboard'
  },
  Medicine: {
    icon: 'medicine',
    title: 'Medicine',
    options: [],
    redirectUrl: '/app/medicine/dashboard'
  },
  Maternity: {
    icon: 'maternity',
    title: 'Maternity',
    options: [],
    redirectUrl: '/app/maternity/dashboard'
  },
  AhcOnboarding: {
    icon: 'maternity',
    title: 'AHC OnBoarding',
    options: [],
    redirectUrl: '/app/ahcOnboarding/EntityCreation'
  },
  WalletDetails: {
    icon: 'mbGold',
    title: 'Wallet Details',
    options: [],
    redirectUrl: '/app/wallet/dashboard'
  },
  Insurer: {
    icon: 'mbGold',
    title: 'Insurer',
    options: [],
    redirectUrl: '/app/insurer/reimbursement'
  },
  Affinity: {
    icon: 'mbGold',
    title: 'Plan Activations',
    options: [],
    redirectUrl: '/app/affinity/mis'
  },
  Onsite: {
    icon: 'ahc',
    title: 'On-Site',
    options: [],
    redirectUrl: '/app/onsite/repository'
  },
  CustomDashboard: {
    icon: 'ahc',
    title: 'Custom Dashboard',
    options: [],
    redirectUrl: '/app/superset/eyoc'
  },
  CorpHealthReport: {
    icon: 'ahc',
    title: 'Corporate Health Report',
    options: [],
    redirectUrl: '/app/superset/CorpHealthReport'
  },
  HealthTrends: {
    icon: 'ahc',
    title: 'Health Trends Analytics',
    options: [],
    redirectUrl: '/app/health-trends/dashboard'
  },
  Data_Management:{
    icon: 'mbGold',
    title: 'Data Management',
    options: [],
    redirectUrl: '/app/data-management/user-benef-creation'
  }

};

const subServices = {
  'Vaccination - Dashboard': {
    href: '/app/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  'Vaccination - Bookings': {
    href: '/app/employees',
    icon: UsersIcon,
    title: 'Bookings'
  },
  'Vaccination - Uploads': {
    href: '/app/reports',
    icon: CloudQueueIcon,
    title: 'Uploads'
  },
  'AHC - Dashboard': {
    href: '/app/ahc/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  'AHC - Employees': {
    href: '/app/ahc/employees',
    icon: UsersIcon,
    title: 'Employees'
  },
  'AHC - Repository': {
    href: '/app/ahc/repository',
    icon: Archive,
    title: 'Repository'
  },
  'AHC - Create Appointment': {
    href: '/app/ahc/createAppointment',
    icon: PlusSquare,
    title: 'Create Appointment'
  },
  'AHC - Eligibility': {
    href: '/app/ahc/eligibility',
    icon: PlusSquare,
    title: 'Employee Eligibility'
  },
  'AHC - Create Appointment Bookings': {
    href: '/app/ahc/createAppointmentBookings',
    icon: UsersIcon,
    title: 'Create Appointment Bookings'
  },
  'AHC - CYE': {
    href: '/app/ahc/cye',
    icon: UsersIcon,
    title: 'Check Employee Eligibility'
  },
  'AHC - MIS': {
    href: '/app/ahc/mis',
    icon: UsersIcon,
    title: 'MIS'
  },
  // 'AHC - PHS Dashboard' : {
  //   href : '/app/ahc/phsdash',
  //   icon : BarChartIcon,
  //   title : "PHS"
  // },
  'AHC - PHS Invoice': {
    href: '/app/ahc/phsinvoice',
    icon: UsersIcon,
    title: 'PHS Invoiced'
  },
  'AHC - PHS MIS': {
    href: '/app/ahc/phsmis',
    icon: UsersIcon,
    title: 'PHS MIS'
  },
  'AHC - PHS Leaderboard Below 40': {
    href: '/app/ahc/phsleaderboard',
    icon: BarChartIcon,
    title: 'PHS Leaderboard Below 40'
  },
  'Gold - Dashboard': {
    href: '/app/gold/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  'Gold - Employees': {
    href: '/app/gold/employees',
    icon: UsersIcon,
    title: 'Employees'
  },
  'Medicine - Dashboard': {
    href: '/app/medicine/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  'Medicine - Provider': {
    href: '/app/medicine/providerwise',
    icon: BarChartIcon,
    title: 'Provider'
  },
  'Medicine - Utilization': {
    href: '/app/medicine/utilization',
    icon: BarChartIcon,
    title: 'Utilization'
  },
  'Medicine - Track Order': {
    href: '/app/medicine/trackOrder',
    icon: BarChartIcon,
    title: 'Track Orders'
  },
  'Medicine - MIS': {
    href: '/app/medicine/mis',
    icon: BarChartIcon,
    title: 'MIS'
  },
  'Maternity - Dashboard': {
    href: '/app/maternity/dashboard',
    icon: BarChartIcon,
    title: 'Dashboard'
  },
  'Maternity - Employees': {
    href: '/app/maternity/employees',
    icon: UsersIcon,
    title: 'Employees'
  },
  'AhcOnboarding - EntityCreation': {
    href: '/app/ahcOnboarding/EntityCreation',
    icon: UsersIcon,
    title: 'EntityCreation'
  },
  'AhcOnboarding - PackageCreation': {
    href: '/app/ahcOnboarding/PackageCreation',
    icon: UsersIcon,
    title: 'PackageCreation'
  },
  'AhcOnboarding - PropertyCreation': {
    href: '/app/ahcOnboarding/PackageProperty',
    icon: UsersIcon,
    title: 'PropertyCreation'
  },
  'AhcOnboarding - WalletConfiguration': {
    href: '/app/ahcOnboarding/WalletConfiguration',
    icon: UsersIcon,
    title: 'WalletConfiguration'
  },
  'WalletDetails - Dashboard': {
    href: '/app/wallet/dashboard',
    icon: UsersIcon,
    title: 'Wallet History'
  },
  'Insurer - Reimbursement': {
    href: '/app/insurer/reimbursement',
    icon: UsersIcon,
    title: 'Reimbursement'
  },
  'Insurer - ViewDocs': {
    href: '/app/insurer/viewDocs',
    icon: FileIcon,
    title: 'ViewDocs'
  },
  'Insurer - Cashless': {
    href: '/app/insurer/cashless',
    icon: UsersIcon,
    title: 'Cashless'
  },
  'Affinity - MIS': {
    href: '/app/affinity/mis',
    icon: UsersIcon,
    title: 'MIS'
  },
  'Onsite - Repository': {
    href: '/app/onsite/repository',
    icon: Archive,
    title: 'Repository'
  },
  'CustomDashboard - EYOC': {
    href: '/app/superset/eyoc',
    icon: UsersIcon,
    title: 'EYOC',
    dashboardId: 3364
  },
  'CustomDashboard - TCSBelowForty': {
    href: '/app/superset/tcsbelowforty',
    icon: UsersIcon,
    title: 'TCS below 40',
    dashboardId: 3244
  },
  'AHC_Dashboard - BOSCH_Utilization': {
    href: '/app/superset/Utilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4770
  },
  'AHC_Dashboard - CAR': {
    href: '/app/superset/CAR',
    icon: UsersIcon,
    title: 'CAR Dashboard',
    dashboardId: 5189
  },
  'AHC_Dashboard - Utilization': {
    href: '/app/superset/Utilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4770
  },
  'CustomDashboard - NestleBusinessServices': {
    href: '/app/superset/NestleBusinessServices',
    icon: UsersIcon,
    title: 'Nestle Business Services',
    dashboardId: 4691
  },
  'CustomDashboard - NestleIndiaLimited': {
    href: '/app/superset/NestleIndiaLimited',
    icon: UsersIcon,
    title: 'Nestle India Limited',
    dashboardId: 4684
  },
  'CustomDashboard - Airtel': {
    href: '/app/superset/Airtel',
    icon: UsersIcon,
    title: 'Airtel',
    dashboardId: 4711
  },
  'OPD - CorpWallet': {
    href: '/app/superset/OPDCorpUtilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4960
  },
  'OPD - CorpWallet_RI': {
    href: '/app/superset/OPDCorpRIUtilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4936
  },
  'OPD - MA': {
    href: '/app/superset/OPDMAUtilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4910
  },
  'GOLD_Utilization - Utilization': {
    href: '/app/superset/GOLDUtilization',
    icon: UsersIcon,
    title: 'Utilization',
    dashboardId: 4962
  },
  'CorpHealthReport - Dashboard': {
    href: '/app/superset/CorpHealthReport',
    icon: UsersIcon,
    title: 'Dashboard',
    dashboardId: 5189
  },
  'Data_Management - BenefCreation': {
    href: '/app/data-management/user-benef-creation',
    icon:UsersIcon,
    title:'User/Beneficiary Creation',
  },
  'HealthTrends - Dashboard': {
    href: '/app/health-trends/dashboard',
    icon: UsersIcon,
    title: 'Dashboard'
  },
  'Data_Management - UserUpdation': {
    href: '/app/data-management/user-updation',
    icon:UsersIcon,
    title:'User Updation/Inactivation',
  },
  'Data_Management - BenefUpdation': {
    href: '/app/data-management/benef-updation',
    icon:UsersIcon,
    title:'Beneficiary Updation/Inactivation',
  }
  
};

export { services, subServices };
